module.exports = __webpack_public_path__ + "img/HowItWorks-Process.77e132c2.jpg";